// Migration: v6 → v7
// Over time widgets gained required fields (e.g. heading/paragraph typography
// fields, labelColor) without a backfill migration, so older stored widgets
// are missing them. Backfill every missing field on each widget from the
// shared structural defaults, and drop the obsolete string `level` that
// legacy headings carried (e.g. "h1").

import { WIDGET_STRUCTURAL_DEFAULTS } from '../consts/widget-structural-defaults';
import type { MigratableTemplateContent } from './types';

const HEADING_TYPES = new Set(['heading1', 'heading2', 'heading3']);

const structuralDefaults = WIDGET_STRUCTURAL_DEFAULTS as Record<
  string,
  Record<string, unknown>
>;

const backfillWidget = (widget: Record<string, unknown>): void => {
  const type = widget.type;
  if (typeof type !== 'string') return;
  const defaults = structuralDefaults[type];
  if (!defaults) return;

  // legacy heading used a string `level` (e.g. "h1") that no longer exists
  if (HEADING_TYPES.has(type)) {
    delete widget.level;
  }

  for (const [key, value] of Object.entries(defaults)) {
    if (widget[key] === undefined) {
      widget[key] = structuredClone(value);
    }
  }
};

export const migrateV6ToV7 = (data: MigratableTemplateContent): void => {
  const widgets = data.widgets;
  if (widgets && typeof widgets === 'object' && !Array.isArray(widgets)) {
    for (const rawWidget of Object.values(widgets)) {
      backfillWidget(rawWidget as Record<string, unknown>);
    }
  }
  data.version = '7';
};
